export interface ByStoreType {
  [key: string]: string[];
}
interface CSSError {
  code: number;
}
export interface Breadcrumb {
  url?: string;
  text: string;
}

export interface CSSLocation {
  [key: string]: any;
  type: string;
  url?: string;
}

export interface Communication {
  notificationType: string;
  communicationType: string;
}

export interface ReminderType {
  notificationType: string;
  reminderTriggerTime: number;
}

export interface EventRegistrationSettings {
  childrenAllowed: boolean;
  childrenIncludedInCount: boolean;
  childrenOnlyEvent: boolean;
  childrenPerRegistration: number;
  participantsPerRegistration: number;
  registrationCloseTime: number;
  registrationRequired: boolean;
  registrationStarts: string;
  reminders: ReminderType[];
  waitingListEnabled?: boolean;
}

export enum EventLoyaltyType {
  FREE_FOR_ALL = 'NO_RESTRICTIONS',
  IKEA_FAMILY_ONLY = 'IKEA_FAMILY_ONLY',
  IKEA_BUSINESS_NETWORK_ONLY = 'IKEA_BUSINESS_NETWORK_ONLY',
  DIGITAL = 'DIGITAL',
}

export type EventLoyaltyTypeRecord = Record<EventLoyaltyType, string>;
export interface CSSEvent {
  [key: string]: any;
  id: string;
  eventImagePath: string;
  reminderType: string;
  timeSlots: TimeSlot[];
  location: CSSLocation;
  visibilityState?: 'ACTIVE' | 'REMOVED' | 'PAST';
  communications: Communication[];
  timeZone: string;
  registrationSettings?: EventRegistrationSettings;
  loyalty?: EventLoyaltyType | undefined;
  allowMultipleRegistrations?: boolean;
}
export interface CSSLiveBroadCast {
  [key: string]: any;
  id: string;
  title: string;
  label: string;
  description: string;
  backgroundImage: string;
  linkToLiveBroadCast: CSSLocation;
}
export interface CSSEventMap {
  [key: string]: CSSEvent;
}

export interface Store {
  storeNo: string;
  storeOtherName: string;
  storeName: string;
  retailCode: string;
  slug: string;
  street: string;
  zipCode: string;
  city: string;
}

export interface StoreMap {
  [key: string]: Store;
}

export enum LoyaltyPrograms {
  ikeaFamily = 'IKEA_FAMILY',
  ikeaBusinessNetwork = 'IKEA_BUSINESS',
}

export interface User {
  firstName: string;
  lastName: string;
  loyalty: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  partyUId: string;
  contact: {
    EMAIL?: string;
    SMS?: string;
  };
  companyName?: string;
  loyaltyPrograms: LoyaltyPrograms[] | [];
}

export interface AppState {
  stores: StoreMap;
  selectedStore: string | null;
  pageError: CSSError | null;
  events: CSSEventMap;
  byStore: ByStoreType;
  digitalEvents: string[];
  selectedEvent: string | null;
  selectedTimeslot: string | null;
  user: User | null;
  breadcrumbs: Array<Breadcrumb>;
}

interface TimeSlotRegistrationSettings {
  maxRegistrationCount: number;
  allowChildren?: boolean;
  maxWaitingListCount: number;
  allowedExtraParticipants?: number;
}

export interface Registration {
  adultCount: number;
  childCount: number;
  creationTime: number;
  preferredContactMethod: string;
  state: string;
  userId: string;
  waitingListPosition: number;
  pageLang: string;
}

export interface CheckinRegistration {
  adultCount: number;
  childCount: number;
  creationTime?: number;
  contactMethods: string[];
  state: string;
  userId: string;
  waitingListPosition?: number;
  firstName?: string;
  lastName?: string;
  customerType?: 'business' | 'individual' | string;
}

export interface TimeSlot {
  startDate: string;
  endDate: string;
  utcEndDate: number;
  utcStartDate: number;
  timeslotId: string;
  currentRegistrationCount: number;
  registration: Registration | null;
  registrations?: Registration[] | null | any;
  registrationRequired: boolean;
  remainingSpots?: number;
  registrationClosedDate?: string | null;
  utcRegistrationClosedDate?: number | undefined;
  registrationSettings: TimeSlotRegistrationSettings;
  currentWaitingListCount: number;
  registerToWaitingList?: boolean;
  visibilityState: string;
}

export interface RegisterObject {
  contactMethods?: string[];
  state: string;
  adultCount: number;
  childCount?: number;
  guests?: number;
  pageLang: string;
}